// assets/product-gallery-custom.js
(() => {
  const SELECTORS = {
    gallery: "[data-pgc-gallery]",
    mainImg: "[data-pgc-main-img]",
    thumb: "[data-pgc-thumb]",
    prev: "[data-pgc-prev]",
    next: "[data-pgc-next]",
    track: "[data-pgc-track]",
  };

  function buildUrlWithWidth(url, width) {
    // Shopify CDN URLs often include ?v=...&width=1600
    // Replace width param if present, else append it.
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set("width", String(width));
      return u.toString();
    } catch (e) {
      // fallback for weird relative URLs
      if (url.includes("width=")) return url.replace(/width=\d+/g, `width=${width}`);
      const join = url.includes("?") ? "&" : "?";
      return `${url}${join}width=${width}`;
    }
  }

  function setMainImage(mainImgEl, fullUrl, altText) {
    if (!mainImgEl || !fullUrl) return;

    const src600 = buildUrlWithWidth(fullUrl, 600);
    const src900 = buildUrlWithWidth(fullUrl, 900);
    const src1200 = buildUrlWithWidth(fullUrl, 1200);
    const src1600 = buildUrlWithWidth(fullUrl, 1600);

    mainImgEl.src = src1600;
    mainImgEl.srcset = `${src600} 600w, ${src900} 900w, ${src1200} 1200w, ${src1600} 1600w`;
    if (typeof altText === "string") mainImgEl.alt = altText;
  }

  function scrollThumbIntoView(trackEl, thumbBtn) {
    if (!trackEl || !thumbBtn) return;

    // Center the selected thumb inside the track (smooth)
    const trackRect = trackEl.getBoundingClientRect();
    const btnRect = thumbBtn.getBoundingClientRect();
    const currentScrollLeft = trackEl.scrollLeft;

    const btnCenter = btnRect.left + btnRect.width / 2;
    const trackCenter = trackRect.left + trackRect.width / 2;

    const delta = btnCenter - trackCenter;
    trackEl.scrollTo({
      left: currentScrollLeft + delta,
      behavior: "smooth",
    });
  }

  function activateThumb(galleryEl, thumbBtn) {
    if (!galleryEl || !thumbBtn) return;

    const trackEl = galleryEl.querySelector(SELECTORS.track);
    const mainImgEl = galleryEl.querySelector(SELECTORS.mainImg);
    const thumbs = Array.from(galleryEl.querySelectorAll(SELECTORS.thumb));

    thumbs.forEach((b) => b.classList.remove("is-active"));
    thumbBtn.classList.add("is-active");

    const full = thumbBtn.getAttribute("data-full");
    const alt = thumbBtn.getAttribute("data-alt") || "";

    setMainImage(mainImgEl, full, alt);
    scrollThumbIntoView(trackEl, thumbBtn);
  }

  function getActiveIndex(galleryEl) {
    const thumbs = Array.from(galleryEl.querySelectorAll(SELECTORS.thumb));
    const idx = thumbs.findIndex((b) => b.classList.contains("is-active"));
    return { thumbs, idx: idx === -1 ? 0 : idx };
  }

  function initGallery(galleryEl) {
    if (!galleryEl || galleryEl.dataset.pgcInit === "1") return;

    const mainImgEl = galleryEl.querySelector(SELECTORS.mainImg);
    const trackEl = galleryEl.querySelector(SELECTORS.track);
    const prevBtn = galleryEl.querySelector(SELECTORS.prev);
    const nextBtn = galleryEl.querySelector(SELECTORS.next);
    const thumbs = Array.from(galleryEl.querySelectorAll(SELECTORS.thumb));

    // Nothing to do
    if (!mainImgEl || thumbs.length === 0) {
      galleryEl.dataset.pgcInit = "1";
      return;
    }

    // Mark as initialized
    galleryEl.dataset.pgcInit = "1";

    // (Opcional) Si quieres evitar que al hacer click en la imagen grande se abra zoom/lightbox del tema,
    // bloquea SOLO ese click (no toda la galería):
    mainImgEl.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    // Thumb click
    thumbs.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        activateThumb(galleryEl, btn);
      });
    });

    // Prev/Next
    if (prevBtn) {
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { thumbs, idx } = getActiveIndex(galleryEl);
        const prevIdx = Math.max(0, idx - 1);
        activateThumb(galleryEl, thumbs[prevIdx]);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { thumbs, idx } = getActiveIndex(galleryEl);
        const nextIdx = Math.min(thumbs.length - 1, idx + 1);
        activateThumb(galleryEl, thumbs[nextIdx]);
      });
    }

    // Ensure first thumb is active if none is active
    const active = thumbs.find((b) => b.classList.contains("is-active")) || thumbs[0];
    activateThumb(galleryEl, active);

    // Safety
    if (trackEl) trackEl.style.scrollBehavior = "smooth";
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.gallery).forEach(initGallery);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", initAll);
})();
